import { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../hooks/AuthProvider';
import { CircularProgress, Box } from '@mui/material';

const Login = () => {
  const { authenticated, loading, login } = useAuth();

  useEffect(() => {
    if (!loading && !authenticated) {
      login();
    }
  }, [loading, authenticated, login]);

  if (authenticated) {
    return <Navigate to="/home" replace />;
  }

  return (
    <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
      <CircularProgress />
    </Box>
  );
};

export default Login;
